<template>
    <div>
        <div class="com-header">
            <div class="com-header-center-container">
                <a class="com-header-logo-link" id="J_logo" target="_blank" :href="indexUrl"></a>
                <ul class="com-menu-list-box">
                    <li><a class="com-menu-btn" id="J_index" target="_blank" :href="indexUrl">首页</a></li>
                    <li><a class="com-menu-btn selected" target="_blank"  :href="`${indexUrl}/myapp/`">应用市场</a><i class="com-hot"></i></li>
                    <li><a class="com-menu-btn" target="_blank" href="http://open.qq.com/">开放平台</a>
                </li>
                <li class="com-borderR">
                    <a class="com-menu-btn" href="http://1.qq.com/yingyongbao/" target="_blank">网页游戏</a>
                    <i class="com-hot com-new"></i>
                </li>
                </ul>
                <div class="clear"></div>
            </div>
        </div>
        <div class="com-nav">
            <div class="com-nav-center-container">
                <ul class="com-nav-list-box">
                    <li>
                      <a :class="`com-nav-btn ${menu === 'index' ? 'selected' : ''}`" href='#'>广场</a>
                    </li>
                </ul>
                <header-search></header-search>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import HeaderSearch from './header-search.vue';
import { sourceMap, onlineMap, pageTitle, baseUrl } from '../utils/tools';
export default {
  name: 'Header',
  components: {
    'header-search': HeaderSearch
  },
  data () {
    return {
      // 首页地址
      indexUrl: 'https://sj.qq.com',
      // 渠道ID
      comAsistanturlid: '990499',
      sourceFile: sourceMap(),
      imgRand: onlineMap(),
      appendChild: '',
      // TODO 请求接口获取appDetail
      appDetail: '',
      menu: 'index',
      baseUrl: ''
    };
  },
  methods: {
    initHeader () {
      const appDetail = this.appDetail;

      const title = document.querySelector('title');
      title.innerText = pageTitle;

      const head = document.querySelector('head');
      const meta = document.createElement('meta');
      meta.setAttribute('itemprop', 'image');
      if (appDetail) {
        if (appDetail.iconUrl) {
          meta.setAttribute('content', appDetail.iconUrl);
        } else {
          meta.setAttribute('content', 'https://pp.myapp.com/ma_icon/0/icon_5848_1521109256/96.png');
        }
      } else {
        meta.setAttribute('content', 'https://pp.myapp.com/ma_icon/0/icon_5848_1521109256/96.png');
      }
      head.appendChild(meta);
    }
  },
  created () {
    this.initHeader();
    this.baseUrl = baseUrl;
  }
};
</script>

<style lang="less" scoped>

</style>
